import { Input } from 'antd';
import styled from 'styled-components/macro';

export const StyledTextArea = styled(Input.TextArea)`
  &:disabled {
    color: #2d394b;
  }
`;
